/**
 *  @class
 *  @function ProductsBadgeSidebar
 */
if (!customElements.get('products-badge-sidebar')) {
  class ProductsBadgeSidebar extends HTMLElement {
    #controller;

    connectedCallback() {
      this.#controller?.abort();
      this.#controller = new AbortController();
      const { signal } = this.#controller;

      this.buttons = [...this.querySelectorAll('.products-badge-button')];
      this.content = [...this.querySelectorAll('.products-badge-content-inner')];
      for (const [index, button] of this.buttons.entries()) {
        button.addEventListener('pointerenter', () => this.#activate(index), { signal });
        button.addEventListener('focus', () => this.#activate(index), { signal });

        if (button.matches('[role="tab"]')) {
          button.addEventListener('click', () => this.#activate(index), { signal });
          button.addEventListener('keydown', (event) => this.#onKeydown(event, index), { signal });
        }
      }

      this.images = this.querySelectorAll('img');
      if (document.readyState === 'complete') {
        this.#unveilImages();
      } else {
        window.addEventListener('load', () => this.#unveilImages(), { once: true, signal });
      }
    }

    disconnectedCallback() {
      this.#controller?.abort();
    }

    #onKeydown(event, index) {
      const keyActions = {
        ArrowDown: 1,
        ArrowRight: 1,
        ArrowUp: -1,
        ArrowLeft: -1,
        Home: -index,
        End: this.buttons.length - 1 - index
      };
      if (!(event.key in keyActions)) return;

      event.preventDefault();
      const nextIndex = (index + keyActions[event.key] + this.buttons.length) % this.buttons.length;
      this.buttons[nextIndex].focus();
    }

    #activate(activeIndex) {
      this.content.forEach((content, index) => {
        const isActive = index === activeIndex;
        content.classList.toggle('active', isActive);
        content.hidden = !isActive;
      });
      this.buttons.forEach((item, index) => {
        const isActive = index === activeIndex;
        item.classList.toggle('active', isActive);
        if (item.matches('[role="tab"]')) {
          item.setAttribute('aria-selected', String(isActive));
          item.tabIndex = isActive ? 0 : -1;
        }
      });
    }

    #unveilImages() {
      for (const image of this.images) {
        if (typeof lazySizes !== 'undefined' && lazySizes.loader) {
          lazySizes.loader.unveil(image);
        }
      }
    }
  }
  customElements.define('products-badge-sidebar', ProductsBadgeSidebar);
}
